
import { required } from 'vuelidate/lib/validators'

export default {
  guest: {
    name: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/guest/form/resources/validations.js